<aionz-generic-purchase-request-dialog
  [title]="'Fornecedores disponíveis para cotação'"
  [description]="
    `Encontramos um total de ${suppliers.length} ${('fornecedor' | pluralizador: suppliers.length)} ${('disponível' | pluralizador: suppliers.length)}, caso deseje incluir mais algum basta adicionar ao lado.`
  "
  [declineButtonText]="'Cancelar'"
  [approveButtonText]="'Confirmar'"
  [showDeclineButton]="false"
  [showApproveButton]="false"
  (onCancel)="close()">
  <button
    headerAction
    mat-flat-button
    color="primary"
    (click)="addNew()">
    Adicionar novo
  </button>

  <seed-card-table
    tableContent
    [scrollOnOverflow]="true">
    <seed-card-table-body>
      <table
        mat-table
        [dataSource]="dataSource()"
        matSort>
        <!-- Coluna "Nome" desativada a pedido do usuário (redundante com fantasyName) —
             mantida comentada, não removida, caso precise reativar.
        <ng-container matColumnDef="name">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            Nome
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            {{ row.name }}
          </td>
        </ng-container>
        -->

        <ng-container matColumnDef="fantasyName">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            Nome Fantasia
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            <div class="flex-row items-center gap-8 fantasy-name-cell">
              @if (row.isVerified) {
                <img
                  class="file"
                  [ngSrc]="'assets/icons/verify.svg'"
                  [width]="16"
                  [height]="16"
                  alt="verify-icon" />
              }
              {{ row.fantasyName }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="cnpj">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            CNPJ
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            {{ row.cnpj | mask: 'AA.AAA.AAA/AAAA-00' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="phone">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            Telefone
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            {{ row.phone | mask: '(00) 0000-0000||(00) 0 0000-0000||+00 (00) 0000-0000||+00 (00) 0 0000-0000' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            E-mail
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            {{ row.email }}
          </td>
        </ng-container>

        <ng-container matColumnDef="source">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            Origem
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            @if (isSuggestedByCotAI(row)) {
              <aionz-kanban-chip-badge
                label="eBarn Cotai"
                icon="auto_awesome"
                color="var(--mat-sys-primary)"
                tooltip="Fornecedor sugerido automaticamente pela Cotação Inteligente"
                [compact]="true" />
            } @else {
              {{ sourceLabel(row.source) ?? '—' }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            Status
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            @let badge = statusBadge(row);
            <aionz-kanban-chip-badge
              [label]="badge.label"
              [tooltip]="badge.tooltip"
              [icon]="badge.icon"
              [color]="badge.color"
              [compact]="true" />
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th
            mat-header-cell
            *matHeaderCellDef>
            Ações
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            <div class="actions-cell flex-row items-center gap-8">
              @if (row.linkStatus === PurchaseSupplierLinkStatus.PENDENTE) {
                <button
                  mat-icon-button
                  type="button"
                  class="approve-icon"
                  [attr.aria-label]="'Aceitar fornecedor sugerido ' + row.name"
                  (click)="onApproveSuggestedSupplier(row)">
                  <mat-icon>check</mat-icon>
                </button>
              }
              <button
                mat-icon-button
                type="button"
                class="delete-icon"
                [attr.aria-label]="'Remover fornecedor ' + row.name"
                (click)="onDeleteSupplier(row)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"></tr>

        <tr
          class="mat-row"
          *matNoDataRow>
          <td
            class="mat-cell text-center py-3"
            colspan="7">
            Nenhum fornecedor encontrado!
          </td>
        </tr>
      </table>
    </seed-card-table-body>
  </seed-card-table>
</aionz-generic-purchase-request-dialog>
